import { User } from '@models/User';
import { createActions } from 'redux-actions';

export type State = {
  user?: User | null;
  errors: string[];
};

export type StateUpdatePayload = Partial<State>;

export const { passwordUpdate, otpUserFetch, stateUpdate } = createActions(
  'PASSWORD_UPDATE',
  'OTP_USER_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_OTP_PASSWORD',
  },
);
